import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { SearchBarModule } from './search-bar/search-bar.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        SearchBarModule,
        MatAutocompleteModule,
        ReactiveFormsModule
    ],
    exports: [
        SearchBarComponent
    ]
})
export class LocationModule {}
